export default "__VITE_ASSET__B3kdQCzb__"